/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKExitMessageHandler = function() {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKExitMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKExitMessageHandler")

com.inq.flash.client.control.messagehandlers.CMSDKExitMessageHandler.prototype.processMessage = function(message) {
	var conversationResolved = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_RESOLVED) === "true";
	var evtData = {
		conversationResolved: conversationResolved
	};
	com.inq.flash.client.control.FlashPeer.setEventDataForSurvey(evtData);
	var forcedClose = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_FORCED_CLOSE);
	if (conversationResolved) {
		if (!forcedClose) {
			com.inq.flash.client.control.FlashPeer.fireConversationResolvedEvent();
		}
		com.inq.flash.client.control.FlashPeer.resetConversationManager();
		com.inq.flash.client.chatskins.SkinControl.conversationActive = false;
	}
	var didClientDisconnect = false;
	//This applies when chat is supported in multiple windows/tabs (e.g embedded chats) and user closes the chat in one window
	if (com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT === message.getMessageType()
		&& "client" === message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USER_TYPE)) {
		didClientDisconnect = true;
	} else {
		com.inq.flash.client.control.FlashPeer.setAgentClosedChat(true);
	}

	this.getController().msgcntAtEntry = 0;
	this.getController().clientDisconnect = didClientDisconnect || !!forcedClose;
	if (this.getController().getChat().isAsyncChat() && (this.getController().getChat().isCiEnabledOnResolve() || !conversationResolved)  && !forcedClose){
		var chatID = this.getController().getChat().getChatID();
		this.getController().shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CMSDK_EXIT);
		com.inq.flash.client.control.FlashPeer.endChatSession(chatID);
		com.inq.flash.client.control.PersistenceManager.ClearValues();
		com.inq.flash.client.control.PersistenceManager.Close();
		com.inq.flash.client.control.PersistenceManager.reopen();
	} else {
		this.getController().shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CMSDK_EXIT);
	}
	this.getController().disable();

	if (this.getController().getChat().isAsyncChat() && (this.getController().getChat().isCiEnabledOnResolve() || !conversationResolved) && !forcedClose) {
		com.inq.flash.client.control.FlashPeer.reinitializeChatWithNewId();
        message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_REINITIED, true);
	}
	this.controller.onNewChatRouterMessage(message);
};
